import React from 'react';
import '../App.css';
import image_1 from './../images_sj/middle.jpg';
import "animate.css/animate.min.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

export default class AboutUs extends React.Component {

    render() {
        return (
            <div className="container aboutUs-custom-top  container-sm ">
                <div id="#scrolly-div" className="row add-mobile-padding">
                    <div className="col-sm-6 col-md-6 mt-sm-5">
                        <div className="row mt-sm-5">
                            <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                <span><hr className="slash"></hr></span>
                            </div>
                            <div className="col-10 col-sm-11">
                                <p data-aos="fade-left" data-aos-duration="1000" className="about-topic"> ABOUT US</p>
                            </div>
                        </div>
                        <div className="row">
                            <p className="about-sub-topic">
                                <span style={{ color: '#2c3e50' }}>ABOUT OUR</span> 
                                <span style={{ color: '#cd853f' }}> COMPANY</span>
                            </p>
                        </div>
                        <div className="row">
                            <div className="col-sm-8 col-md-12">
                                <p
                                  data-aos="fade-right"
                                  data-aos-duration="1000"
                                  data-aos-easing="ease-in-sine"
                                  className="about-text"
                                >
                                  Shree Jeen Interiors is a Bengaluru-based interior design and execution company, renowned for creating visually stunning and functionally smart
                                  spaces that reflect the personality, purpose, and lifestyle of our clients. With over 15 years of on-site experience, we specialize in delivering customized,
                                  high-quality interiors - on time and within budget. From homes and apartments to shops, showrooms, and offices, we provide end-to-end interior
                                  solutions rooted in honesty, innovation, and hands-on craftsmanship.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className="col-sm-6 col-md-6 mt-lg-5">
                        <img className="about-img about-img-tab" src={image_1} alt="about-us-img" style={{ width: '78%', height: '100%', objectFit: 'cover', maxHeight: '400px' }} ></img>
                    </div>
                </div>
            </div >
        )
    };
};



